import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCartItem } from '../../api/apiStorefront';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useUpdateCartItem = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ itemId, data }) => updateCartItem(itemId, data),
    onSuccess: () => {
      toast.success(t('cart.updateSuccess', 'Cart updated successfully!'));
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['cart-count'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || t('cart.updateError', 'Failed to update cart');
      toast.error(message);
    },
  });
};
